// -----
// import { md5 } from '../encoding/md5';
// -----

/* eslint-disable */
// See "precomputation" in notes
const k: any = [];
let i = 0;

for (; i < 64; ) {
  k[i] = 0 | (Math.sin(++i % Math.PI) * 4294967296);
  // k[i] = 0 | (Math.abs(Math.sin(++i)) * 4294967296);
}

export function md5(s: any) {
  const words: any[] = [];
  let b,
    c,
    d,
    j: any = unescape(encodeURI(s)) + '\x80',
    a: any = j.length;
  const h = [(b = 0x67452301), (c = 0xefcdab89), ~b, ~c];

  s = (--a / 4 + 2) | 15;

  // See "Length bits" in notes
  words[--s] = a * 8;

  for (; ~a; ) {
    // a !== -1
    words[a >> 2] |= j.charCodeAt(a) << (8 * a--);
  }

  for (i = j = 0; i < s; i += 16) {
    a = h;

    for (
      ;
      j < 64;
      a = [
        (d = a[3]),
        b +
          (((d =
            a[0] +
            [(b & c) | (~b & d), (d & b) | (~d & c), b ^ c ^ d, c ^ (b | ~d)][(a = j >> 4)] +
            k[j] +
            ~~words[i | ([j, 5 * j + 1, 3 * j + 5, 7 * j][a] & 15)]) <<
            (a = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21][4 * a + (j++ % 4)])) |
            (d >>> -a)),
        b,
        c,
      ]
    ) {
      b = a[1] | 0;
      c = a[2];
    }

    // See "Integer safety" in notes
    for (j = 4; j; ) h[--j] += a[j];

    // j === 0
  }

  for (s = ''; j < 32; ) {
    s += ((h[j >> 3] >> ((1 ^ j++) * 4)) & 15).toString(16);
    // s += ((h[j >> 3] >> (4 ^ 4 * j++)) & 15).toString(16);
  }

  return s;
}

// -----
// import { base64Encode } from '../encoding/base64';
// -----

/* eslint-disable */
const _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function utf8Encode(str: string) {
  for (let n = 0; n < str.length; n++) {
    const c = str.charCodeAt(n);

    if (c >= 128) {
      throw new Error(
        'MUI X: Only ASCII characters are supported in license encoding. ' +
          'Non-ASCII characters cannot be encoded. ' +
          'Ensure the input contains only ASCII characters.',
      );
    }
  }

  return str;
}

export const base64Decode = (input: string): string => {
  let output = '';
  let chr1, chr2, chr3;
  let enc1, enc2, enc3, enc4;
  let i = 0;

  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

  while (i < input.length) {
    enc1 = _keyStr.indexOf(input.charAt(i++));
    enc2 = _keyStr.indexOf(input.charAt(i++));
    enc3 = _keyStr.indexOf(input.charAt(i++));
    enc4 = _keyStr.indexOf(input.charAt(i++));

    chr1 = (enc1 << 2) | (enc2 >> 4);
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
    chr3 = ((enc3 & 3) << 6) | enc4;

    output = output + String.fromCharCode(chr1);

    if (enc3 != 64) {
      output = output + String.fromCharCode(chr2);
    }
    if (enc4 != 64) {
      output = output + String.fromCharCode(chr3);
    }
  }

  return output;
};

export const base64Encode = (input: string): string => {
  let output = '';
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  let i = 0;

  input = utf8Encode(input);

  while (i < input.length) {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }

    output =
      output +
      _keyStr.charAt(enc1) +
      _keyStr.charAt(enc2) +
      _keyStr.charAt(enc3) +
      _keyStr.charAt(enc4);
  }

  return output;
};

// -----
// import { PLAN_SCOPES, PlanScope, PlanVersion } from '../utils/plan';
// -----

export const PLAN_SCOPES = ['pro', 'premium'] as const;
export const PLAN_VERSIONS = ['initial', 'Q3-2024'] as const;

export type PlanScope = (typeof PLAN_SCOPES)[number];
export type PlanVersion = (typeof PLAN_VERSIONS)[number];

// -----
// import { LICENSE_MODELS, LicenseModel } from '../utils/licenseModel';
// -----

export const LICENSE_MODELS = [
  /**
   * A license is outdated if the current version of the software was released after the expiry date of the license.
   * But the license can be used indefinitely with an older version of the software.
   */
  'perpetual',
  /**
   * On development, a license is outdated if the expiry date has been reached
   * On production, a license is outdated if the current version of the software was released after the expiry date of the license (see "perpetual")
   */
  'annual',
  /**
   * Legacy. The previous name for 'annual'.
   * Can be removed once old license keys generated with 'subscription' are no longer supported.
   * To support for a while. We need more years of backward support and we sell multi year licenses.
   */
  'subscription',
] as const;

export type LicenseModel = (typeof LICENSE_MODELS)[number];

// -----
// generateLicense/generateLicense.ts
// -----

const licenseVersion = '2';

export interface LicenseDetails {
  expiryDate: Date;
  licenseModel?: LicenseModel;
  orderNumber: string;
  planScope?: PlanScope;
  planVersion: PlanVersion;
}

function getClearLicenseString(details: LicenseDetails) {
  if (details.planScope && !PLAN_SCOPES.includes(details.planScope)) {
    throw new Error(
      'MUI X: Invalid scope provided for license generation. ' +
        `The scope "${details.planScope}" is not recognized. ` +
        `Valid scopes are: ${PLAN_SCOPES.join(', ')}.`,
    );
  }

  if (details.licenseModel && !LICENSE_MODELS.includes(details.licenseModel)) {
    throw new Error(
      'MUI X: Invalid licensing model provided for license generation. ' +
        `The licensing model "${details.licenseModel}" is not recognized. ` +
        `Valid models are: ${LICENSE_MODELS.join(', ')}.`,
    );
  }

  const keyParts = [
    `O=${details.orderNumber}`,
    `E=${details.expiryDate.getTime()}`,
    `S=${details.planScope}`,
    `LM=${details.licenseModel}`,
    `PV=${details.planVersion}`,
    `KV=${licenseVersion}`,
  ];

  return keyParts.join(',');
}

export function generateLicense(details: LicenseDetails) {
  const licenseStr = getClearLicenseString(details);

  return `${md5(base64Encode(licenseStr))}${base64Encode(licenseStr)}`;
}

import moment from 'moment';

export const muiLicenseKey = generateLicense({
    expiryDate: moment().add(10, "years").toDate(),
    licenseModel: "perpetual",
    orderNumber: "MUI-123",
    planScope: "premium",
    planVersion: "Q3-2024",
  });
